import { useState } from 'react';

import { useScrollToTopOnChange } from './useScrollToOnChange';

export function useCurrentStep<Steps extends string | null>(defaultStep: Steps) {
  const [currentStep, setCurrentStep] = useState<Steps>(defaultStep);

  useScrollToTopOnChange(currentStep);

  return [currentStep, setCurrentStep] as const;
}
